export const ModalLogOutTranslationsCs = {
  LogOut: 'Opravdu chcete odhlásit?',
  yes: 'Ano, odhlásit',
  back: 'Zpět',
};
